module.exports = "/_next/static/images/bg-overlay-439e85eb23da93f6ea835545f1643738.png";